<div class="sf-control" [class.mb-2]="!compact()">
    <div
        class="sf-control-label d-flex align-items-center justify-content-between"
        [class.mb-2]="!inlineLabel() && !compact()">
        <sf-label
            [label]="label()"
            [for]="inputId()"
            [required]="isRequired()"
            [description]="description()"
            [inline]="inlineLabel()"
            [compact]="compact()"></sf-label>
        <sf-ai-text-generator-button
            [useContainer]="false"
            [compact]="compact()"
            [instructions]="aiInstructions()"
            [initialPrompt]="control.value || ''"
            (textGenerated)="onAiTextGenerated($event)"
            size="sm">
        </sf-ai-text-generator-button>
    </div>

    <textarea
        #textarea
        class="form-control"
        [class.form-control-sm]="size() == 'sm'"
        [class.form-control-lg]="size() == 'lg'"
        [required]="isRequired()"
        [id]="inputId()"
        [formControl]="control"
        autocomplete="none"
        [placeholder]="placeholder()"
        [rows]="rows()"
        [maxlength]="maxLength() > 0 ? maxLength() : null"></textarea>

    @if (control.touched && control.dirty && control.errors) {
        @for (err of control.errors | keyvalue; track err) {
            <div class="invalid-feedback d-block">
                {{ errorMessages[err.key] }}
            </div>
        }
    }

    <div class="sf-control-footer d-flex" [class.mt-2]="!compact()">
        @if (maxLength() > 0) {
            <span class="ms-auto small text-body-secondary">{{ control.value?.length || 0 }} / {{ maxLength() }}</span>
        }
    </div>
</div>
